import RequestCreator from './BaseRequest';

// Vou pegar o IpadLanguagesModel do types
const api = new RequestCreator<any>('/ipad/ipad-languages');
export default api;
